/* eslint-disable @typescript-eslint/no-explicit-any */
import { RootElmActionReturnType, sendLocalAction } from 'actions/service/rootElmAction';

export interface FunctionTypes {
  moveTable(
    tableId: number,
    newPosition: { xPosition: number; yPosition: number }
  ): RootElmActionReturnType;
  resetTablePositions(): RootElmActionReturnType;
  updateTableState(tableId: number, newState: any): RootElmActionReturnType;
}

export function moveTable(tableId: number, newPosition: { xPosition: number; yPosition: number }) {
  return sendLocalAction('moveTable', { tableId, newPosition });
}

export function resetTablePositions() {
  return sendLocalAction('resetTablePositions', {});
}

export function updateTableState(tableId: number, newState: any) {
  return sendLocalAction('updateTableState', { tableId, newState });
}
